import { IHeaderParam, IQueryPathParam } from '../../models/services/IServiceOperation';

/**
 * @method objToArrForQueryAndHeader
 * @description Converts an object to an array of query path parameters or header parameters.
 * @param obj - The object to be converted.
 * @returns An array of query path parameters or header parameters.
 */
export const objToArrForQueryAndHeader = (obj: IQueryPathParam[] | { [key: string]: string } | IHeaderParam[] | undefined | null) => {
  let objArr: IQueryPathParam[] | IHeaderParam[] = [];
  const temp = obj;
  if (temp && temp !== null && !Array.isArray(temp) && Object.keys(temp).length > 0) {
    Object.keys(temp).forEach((key) => {
      const mapperObj: IQueryPathParam = {
        key: `${key}`,
        value: `${temp[key]}`
      };
      objArr.push(mapperObj);
    });
  } else {
    objArr = Array.isArray(temp) ? temp : [];
  }
  return objArr;
};
